/** Fixed media heights */
const mediaHeightXs = 170;
const mediaHeightSm = 286;
const mediaHeightMd = 196;
const mediaHeightLg = 240;
const mediaHeightXl = 240;
const mediaHeightXl2Items = 346;

module.exports = (theme) => ({
  ".poster-item-group": {},
  ".poster-item-group-heading": {
    "@apply ds-text-center ds-max-w-[720px] ds-mx-auto sm:!ds-text-6xl sm:!ds-leading-3xl ds-mb-xl md:!ds-mb-2xl": 1,
  },
  ".poster-item-group-container": { "@apply ds-relative": 1 },

  /**
   * Offset background that basically mimics the size and position of base-block-background-container (base-block.js), but
   * pushed down by 50% relative to current media height. Calculation of left as follows:
   * (background-container max-width - module-container max-width) / 2 + module-container left padding ->
   * (1920px - 1440px) / 2 + 58px
   */
  ".poster-item-group-background": {
    "@apply ds-absolute -ds-left-[298px] ds-w-[1920px] ds-h-full": 1,
    top: `${mediaHeightXs / 2}px`,
  },

  ".poster-item": { "@apply ds-flex ds-flex-col ds-pb-2xl sm:!ds-pb-3xl": 1, overflowWrap: "anywhere" },
  ".poster-item-media": {
    "@apply ds-relative ds-overflow-visible ds-mb-2xl": 1,
    height: `${mediaHeightXs}px`,
  },
  ".poster-item-media img": { "@apply ds-w-full ds-object-cover ds-h-full": 1 },

  [`@media screen and (min-width: ${theme("screens.sm")})`]: {
    ".poster-item-group-background": { top: `${mediaHeightSm / 2}px` },
    ".poster-item-media": { height: `${mediaHeightSm}px` },
  },
  [`@media screen and (min-width: ${theme("screens.md")})`]: {
    ".poster-item-group-background": { top: `${mediaHeightMd / 2}px` },
    ".poster-item-media": { height: `${mediaHeightMd}px` },
  },
  [`@media screen and (min-width: ${theme("screens.lg")})`]: {
    ".poster-item-group-background": { top: `${mediaHeightLg / 2}px` },
    ".poster-item-media": { height: `${mediaHeightLg}px` },
  },
  [`@media screen and (min-width: ${theme("screens.xl")})`]: {
    ".poster-item-group-emphasized .poster-item-group-background": { top: `${mediaHeightXl2Items / 2}px` },
    ".poster-item-group-background": { top: `${mediaHeightXl / 2}px` },

    ".poster-item-group-emphasized .poster-item-media": { height: `${mediaHeightXl2Items}px` },
    ".poster-item-media": { height: `${mediaHeightXl}px` },
  },

  ".poster-item-content": { "@apply ds-flex ds-flex-col ds-grow ds-gap-xl": 1 },
  ".poster-item-heading": { "@apply sm:!ds-text-4xl sm:!ds-leading-xl": 1 },
  ".poster-item-text": { "@apply ds-text ds-mb-auto": 1 },
});
